import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';

import {gettext} from 'utils/text';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';


const tableColumns = [
    // A hidden product id column is used for excel export GET request data
    {
        Header: gettext("Product id"),
        accessor: 'productId',
        show: false,
    },
    {
        Header: gettext("Welder"),
        accessor: 'welder',
    },
    {
        Header: gettext("Order number"),
        accessor: 'orderNumber',
    },
    {
        Header: gettext("Product"),
        accessor: 'product',
    },
    {
        Header: gettext("Estimated time"),
        accessor: 'estimatedTime',
    },
    {
        Header: gettext("Actual time"),
        accessor: 'actualTime',
    },
    {
        Header: gettext("Difference"),
        accessor: 'difference',
    },
    {
        Header: gettext("Salary change"),
        accessor: 'timeSalaryChange',
    },
    {
        Header: gettext("Tolerance"),
        accessor: 'tolerance',
    },
    {
        Header: gettext("Salary change"),
        accessor: 'toleranceSalaryChange',
    },
    {
        Header: gettext("Quality"),
        accessor: 'quality',
    },
    {
        Header: gettext("Salary change"),
        accessor: 'qualitySalaryChange',
    },
    {
        Header: gettext("Total percentage"),
        accessor: 'totalPercentage',
    },
];


class ReportsTable extends Component {
    static propTypes = {
        selectedStartDay: momentPropTypes.momentObj,
        selectedEndDay: momentPropTypes.momentObj,
        tableRows: PropTypes.arrayOf(PropTypes.shape({
            welder: PropTypes.string.isRequired,
            orderNumber: PropTypes.number.isRequired,
            product: PropTypes.string.isRequired,
            estimatedTime: PropTypes.number.isRequired,
            actualTime: PropTypes.number.isRequired,
            difference: PropTypes.string.isRequired,
            timeSalaryChange: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            tolerance: PropTypes.string.isRequired,
            toleranceSalaryChange: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            quality: PropTypes.string.isRequired,
            qualitySalaryChange: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            totalPercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })).isRequired,
        noDataText: PropTypes.string.isRequired,
        isLoading: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        selectedStartDay: null,
        selectedEndDay: null,
    };

    onExportToExcelClicked = (startDate, endDate) => {
        if (!this.reactTable || !this.reactTable.getResolvedState().sortedData.length) return;

        const productIds = this.reactTable.getResolvedState().sortedData.map(row => row.productId);
        const url = new URL(window.location.href);

        url.searchParams.append('export', 'true');
        url.searchParams.append('ordered-rows', JSON.stringify(productIds));
        url.searchParams.append('start-date', startDate.isValid() ? startDate.format('L') : '');
        url.searchParams.append('end-date', endDate.isValid() ? endDate.format('L') : '');

        window.location = url.href;
    };

    render() {
        const startDate = moment(this.props.selectedStartDay);
        const endDate = moment(this.props.selectedEndDay);
        const {tableRows, isLoading} = this.props;

        return (
            <div>
                <div className="d-flex justify-content-end">
                    <button
                        className="btn btn-info text-uppercase font-weight-bold text-white fs-xs mb-3"
                        onClick={() => this.onExportToExcelClicked(startDate, endDate)}
                        disabled={isLoading || !tableRows.length || !startDate.isValid() || !endDate.isValid()}
                    >
                        <FontAwesomeIcon className="mr-2" icon="file-excel" />{gettext("Export report")}
                    </button>
                </div>
                <ReactTable
                    data={tableRows}
                    ref={(element) => {
                        this.reactTable = element;
                    }}
                    previousText={gettext("Previous")}
                    nextText={gettext("Next")}
                    loadingText={gettext("Loading")}
                    noDataText={this.props.noDataText}
                    rowsText={gettext("rows")}
                    pageText={gettext("Page")}
                    ofText={gettext("of")}
                    columns={tableColumns}
                    defaultPageSize={15}
                    pageSizeOptions={[5, 15, 50, 100]}
                    className="-striped -highlight"
                    loading={isLoading}
                />
            </div>
        );
    }
}


export default ReportsTable;



// WEBPACK FOOTER //
// ./src/components/ReportsTable.js